import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Divider, TextField, MenuItem, SelectField, RaisedButton, DatePicker,
  Card, CardText, Drawer, Dialog, FlatButton, CircularProgress, Chip, List, ListItem, ListItemSecondaryAction, Avatar
} from "material-ui";
import DeleteIcon from "material-ui/svg-icons/action/delete";
import DateIcon from "material-ui/svg-icons/action/date-range";
import Add from "material-ui/svg-icons/content/add-circle";
import Getapp from "material-ui/svg-icons/action/get-app";
import {
  BuscarPaquetes, BuscarTotalPaginas, NuevaPrestacion, Loading, LoadingExcel, obtenerTiposAtencion,
  CambiarTipoAtencion, BuscarBorradorSolicitud, deleteBorrador, OpenCargarBorrador,
  SetSolicitudesEnCurso, GetSolicitudesExcel, ContarRegistros, CambiarInicioVigencia, CambiarTipoAtencion2,
  CambiarTipoAtencion3, CambiarVigencia, CambiarCodIntervencion, CambiarCodPaquetePres, CambiarGlosa
} from "./actions";
import {
  ObtenerCentrosAtencion, ObtenerTiposArancel, ObtenerTiposPrestacion,
  CambiarTipoArancel, CambiarCentroAtencion, CambiarTipoPrestacion,
  CambiarCodFonasa, ObtenerUsuariosPerfil, CambiarCodPrestacion, ObtenerDatosUsuario,
} from "../../Global/actions";
import GrillaBusquedaPQ from "../GrillaBusquedaPQ/view";
import GrillaSolicitud from "../GrillaSolicitud/view";
import NuevaPrestacionForm from "../NuevaPrestacionForm/view";
import ErrorSnack from "../../ErrorSnack/view";
import { AddPrestacionSolicitud, UpdateIdSolicitud } from "../GrillaSolicitud/actions";
import { nuevaSolicitud } from "../GrillaSolicitud/actions";

import guid from "../../../helpers/guid";
import styles from "../../styles/styles";
import apiConfig from "../../../config/api";
import { ObtenerTiposArancelAll } from "../NuevaPrestacionForm/actions";
import banmedicaTheme from "../../../config/banmedicaTheme";
import customDateTimeFormat from "../../../helpers/dateFormat";
// import DialogAlert from "../../../componentsGlobal/DialogAlert";

class FiltroBusquedaPQ extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cambiosSinGuardar: false,
      infoAlert: false,
      disableExcel: false,
    };
  }
  componentWillMount() {
    window.removeEventListener("beforeunload", this.onUnload.bind(this));
    this.props.dispatch(ObtenerUsuariosPerfil(`${apiConfig.usuariosContraloria}`, 1));
    this.props.dispatch(ObtenerUsuariosPerfil(`${apiConfig.usuariosConvenios}`, 2));
    this.props.dispatch(ObtenerCentrosAtencion());
    this.props.dispatch(obtenerTiposAtencion());
    if (!this.props.ENV.DESHABILITAR_BORRADOR) {
      this.props.dispatch(BuscarBorradorSolicitud());
    }
    this.props.dispatch(ObtenerDatosUsuario());
    this.props.dispatch(ObtenerTiposArancelAll());
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onUnload.bind(this));
  }


  onUnload(event) { // the method that will be used for both add and remove event
    if (this.state.cambiosSinGuardar) {
      event.returnValue = true;
    }
  }

  CambiosSinGuardar = (cambios) => {
    this.setState({ cambiosSinGuardar: cambios });
  }

  ExportarExcel = () => {
    this.props.dispatch(LoadingExcel(true));
    this.props.dispatch(GetSolicitudesExcel());
  }

  CambiarTipoArancel = (event, index, value) => {
    this.props.dispatch(CambiarTipoArancel(value));
  }

  CambiarVigencia = (event, index, value) => {
    this.props.dispatch(CambiarVigencia(value));
    if (value != 'S') {
      this.setState({ disableExcel: true });
    } else {
      this.setState({ disableExcel: false });
    }
  }

  CambiarCentroAtencion = (event, index, value) => {
    this.props.dispatch(CambiarCentroAtencion(value));
    this.props.dispatch(ObtenerTiposPrestacion(value));
    this.props.dispatch(ObtenerTiposArancel(value));
  }

  CambiarTipoPrestacion = (event, index, value) => {
    this.props.dispatch(CambiarTipoPrestacion(value));
  }

  CambiarCodFonasa = (event) => {
    const re = /^[0-9;]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      this.props.dispatch(CambiarCodFonasa(event.target.value));
    }
  }

  CambiarCodPrestacion = (event) => {
    this.props.dispatch(CambiarCodPrestacion(event.target.value));
  }

  CambiarGlosa = (event) => {
    this.props.dispatch(CambiarGlosa(event.target.value));
  }

  CambiarCodPaquetePres = (event) => {
    this.props.dispatch(CambiarCodPaquetePres(event.target.value));
  }

  CambiarCodIntervencion = (event) => {
    const re = /^[0-9;]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      this.props.dispatch(CambiarCodIntervencion(event.target.value));
    }
  }


  CambiarTipoAtencion = (event, index, value) => {
    this.props.dispatch(CambiarTipoAtencion(value));
  }

  CargarAtributosTipo = (event, index, value) => {
    this.props.dispatch(CambiarTipoAtencion(value));
  }

  GuardarAtributos = (event, index, value) => {
    const result = this.props.tiposAtencion.filter(tipos => tipos.Tipo === this.props.filtros.tipoAtencion);
    let valor = result.filter(tipos => tipos.Descripcion === value);
    let aux = this.props.filtros.tipoAtencion3
    if (value != 0) {
      if (this.props.filtros.tipoAtencion3.length === 0) {
        aux.push({ Tipo: this.props.filtros.tipoAtencion, Valor: valor[0].Valor, Descripcion: value });
        this.props.dispatch(CambiarTipoAtencion2(value, aux));
      } else {
        let existeAtributo = aux.find(element => element.Tipo === this.props.filtros.tipoAtencion);
        if (existeAtributo) {
          var newArray = aux.filter((item) => (item.Tipo !== this.props.filtros.tipoAtencion && item.Descripcion !== value));
          aux = newArray;
          aux.push({ Tipo: this.props.filtros.tipoAtencion, Valor: valor[0].Valor, Descripcion: value })
          this.props.dispatch(CambiarTipoAtencion2(value, aux));
        } else {
          aux.push({ Tipo: this.props.filtros.tipoAtencion, Valor: valor[0].Valor, Descripcion: value })
          this.props.dispatch(CambiarTipoAtencion2(value, aux));
        }
      }
    } else {//Value === 0
      var newArray = aux.filter((item) => (item.Tipo !== this.props.filtros.tipoAtencion));
      this.props.dispatch(CambiarTipoAtencion2(value, newArray));
    }
  }

  handleDelete = (tipo, valor, descripcion) => {
    var myArray = this.props.filtros.tipoAtencion3;
    var newArray = myArray.filter((item) => (item.Tipo !== tipo && item.Descripcion !== descripcion));
    this.props.dispatch(CambiarTipoAtencion3(newArray));
  };

  BuscarPaquetes = (event, index, value) => {
    this.props.dispatch(Loading(true));
    this.props.dispatch(BuscarPaquetes(value));
    this.props.dispatch(BuscarTotalPaginas(value));
  }

  NuevaPrestacion = () => {
    this.props.dispatch(NuevaPrestacion());
  }

  CloseSetSolicitudesEnCurso = () => {
    this.props.dispatch(SetSolicitudesEnCurso(false, null));
    this.props.dispatch(nuevaSolicitud(null));
  }

  CambiarInicioVigencia = (event, date) => {
    this.props.dispatch(CambiarInicioVigencia(date));
  }

  LimpiarInicioVigencia = (date) => {
    this.props.dispatch(CambiarInicioVigencia(date));
  }

  CargarDetalleSolicitud = () => {
    // this.props.dispatch(GetDetalleSolicitud(this.props.idSolicitud));

    this.props.prestacionesSolicitud.forEach((element) => {
      // Por haber incongruencia en los datos, cuando se carga de base de datos, se setea local
      // La fecha viene en formato zulu porque en base de datos se guarda solo la fecha, sin la hora, cuando regresa, el locate lo pasa a menos 3 horas, visualmente se resta u dia
      // por eso se realiza la tranformacion local, para que pase a gmt
      let FechaInicioVigenciaPosterior = null;
      if (element.FechaInicioVigenciaPosterior) {
        const anho = Number(element.FechaInicioVigenciaPosterior.substring(0, 4));
        const mes = Number(element.FechaInicioVigenciaPosterior.substring(5, 7)) - 1;
        const dia = Number(element.FechaInicioVigenciaPosterior.substring(8, 10));
        FechaInicioVigenciaPosterior = new Date(anho, mes, dia);
      }
      let FechaTerminoVigenciaPosterior = null;
      if (element.FechaTerminoVigenciaPosterior) {
        const anho = Number(element.FechaTerminoVigenciaPosterior.substring(0, 4));
        const mes = Number(element.FechaTerminoVigenciaPosterior.substring(5, 7)) - 1;
        const dia = Number(element.FechaTerminoVigenciaPosterior.substring(8, 10));
        FechaTerminoVigenciaPosterior = new Date(anho, mes, dia);
      }
      // el codigo de operacion, viene en numero, pero en la web se usa como strig, con validacione varias
      const IdTipoAccionPrestacion = element.IdTipoAccionPrestacion ? element.IdTipoAccionPrestacion.toString() : "";

      //console.log("PRESTACION:", element);

      const prest = {
        COD_PRESTADOR: element.CodigoPrestacionPrestador,
        GLOSA_CODPRESTADOR: element.GlosaPrestacionPrestador,
        COD_ISAPRE: element.CodigoPrestacionIsapre,
        PROF_CCOD: element.CodigoProfesionalIsapre,
        VALOR: element.ValorPosterior,
        UNIDAD: element.UnidadPosterior,
        TIPO_ATENCION: element.TipoAtencion,
        // INICIO_VIG: element.IdTipoAccionPrestacion === 2 ? FechaTerminoVigenciaPosterior : FechaInicioVigenciaPosterior,
        INICIO_VIG: FechaInicioVigenciaPosterior,
        FECHA_FIN_VIG: FechaTerminoVigenciaPosterior,
        TIPO_PRESTACION: "",
        GUARISMO: element.GuarismoDP,
        PERTENENCIA_FONASA: element.PertenenciaFonasa,
        CODIGO_FONASA: element.CodigoFonasa,
        ITEM_IMED: element.ItemImedNumber,
        CENTRO_AT: element.CentroAtencion,
        SECUENCIA: element.CentroAtencionSecuencia,
        ARANCEL: element.GlosaArancel,
        RUTARANCEL: element.Arancel,
        IDPRESTACION: element.IdPrestacionIsapre,
        IDDETALLEPRESTACION: element.IdDetallePrestacionSolicitud,
        OPERACION: element.TipoAccionPrestacion,
        COD_OPERACION: IdTipoAccionPrestacion,
        GUID: guid.new(),
      };
      this.props.dispatch(AddPrestacionSolicitud(prest));
    });

    this.props.dispatch(UpdateIdSolicitud(this.props.idSolicitud, true));
    this.ocultarModalBorrador();
  }

  eliminarBorrador = () => {
    this.props.dispatch(deleteBorrador(this.props.idSolicitud, this.props.rutPrestador, this.props.rutInstitucion, this.props.isapre));
    this.ocultarModalBorrador();
  }

  mostrarModalBorrador = () => {
    this.props.dispatch(OpenCargarBorrador(true));
  }

  ocultarModalBorrador = () => {
    this.props.dispatch(OpenCargarBorrador(false));
  }


  render() {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;
    let today = new Date();
    today.setDate(today.getDate() + fechaVigenciaPrestador);
    const minDate = today;

    const menuListTipoArancel = [];
    if (this.props.tiposArancel) {
      this.props.tiposArancel.forEach((element) => {
        menuListTipoArancel.push(<MenuItem key={element.Rut} value={element.Rut} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const menuListCentroAtencion = [];
    if (this.props.centrosAtencion) {
      this.props.centrosAtencion.forEach((element) => {
        menuListCentroAtencion.push(<MenuItem key={element.Secuencia} value={element.Secuencia} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }


    const menuListVigencias = [];
    if (this.props.tiposAtencion) {
      menuListVigencias.push(<MenuItem key="0" value="T" primaryText="Todas" style={styles.customWidthItem} />);
      menuListVigencias.push(<MenuItem key="1" value="S" primaryText="Vigentes" style={styles.customWidthItem} />);
      menuListVigencias.push(<MenuItem key="2" value="N" primaryText="No Vigentes" style={styles.customWidthItem} />);
    }

    const menuListTipoAtributo = [];
    menuListTipoAtributo.push(<MenuItem key="0" value="0" primaryText="Cualquiera" style={styles.customWidthItem} />);
    if (this.props.tiposAtencion) {
      const unique = [...new Set(this.props.tiposAtencion.map(item => item.Tipo))];
      for (let i = 1; i <= unique.length; i++) {
        menuListTipoAtributo.push(<MenuItem key={i} value={unique[i - 1]} primaryText={unique[i - 1]} style={styles.customWidthItem} />);
      }
    }

    const menuListTiposAtributoTipo = [];
    menuListTiposAtributoTipo.push(<MenuItem key="0" value="0" primaryText="Cualquiera" style={styles.customWidthItem} />);
    if (this.props.filtros.tipoAtencion != '0') {
      const result = this.props.tiposAtencion.filter(tipos => tipos.Tipo === this.props.filtros.tipoAtencion);
      for (let i = 1; i <= result.length; i++) {
        menuListTiposAtributoTipo.push(<MenuItem key={i} value={result[i - 1].Descripcion} primaryText={result[i - 1].Descripcion} style={styles.customWidthItem} />);
      }
    }

    const menuListFiltros = [];
    if (this.props.tiposArancel) {
      this.props.filtros.tipoAtencion3.forEach((element, index) => {
        menuListFiltros.push((
          //<List>
          <ListItem
            key={index}
            primaryText={element.Tipo + " - " + element.Descripcion}
            rightIcon={<DeleteIcon onClick={() => this.handleDelete(element.Tipo, element.Valor, element.Descripcion)} />}>
          </ListItem>
          //</List>
        ));
      });
    }

    const actionsModalCargarBorrador = [
      <FlatButton
        label="Eliminar"
        secondary
        onClick={this.eliminarBorrador}
      />,
      <FlatButton
        label="Continuar"
        secondary
        onClick={this.CargarDetalleSolicitud}
      />,
    ];

    return (
      <div>
        {this.props.token ?

          <div >
            <div style={styles.frameContenidoGeneral}>
              <Card zDepth={0} style={{ paddingBottom: 0 }}>
                <CardText style={{ paddingBottom: 0 }}>
                  <div className="row" style={{ paddingBottom: 0 }}>
                    <div className="contenido" style={{ margin: 0, padding: 0, width: 925 }}>
                      <div style={styles.h1}>Listado de Paquetes Quirúrgicos
                      </div>
                      <div className="row" style={{ paddingBottom: 25 }}></div>
                      <div className="row"> </div>
                      <div style={styles.h3}>Rut Institución: {this.props.rutInstitucion}
                      </div>
                    </div>
                  </div>
                  {
                    this.props.tiposAtencion && this.props.tiposAtencion.length > 0 ?
                      <div>
                        <div className="row">
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect}> Glosa Paquete </div>
                            <TextField
                              name="txt_fb_glosa"
                              id="txt_fb_glosa"
                              value={this.props.filtros.glosa || ""}
                              onChange={this.CambiarGlosa}
                              maxLength={200}
                              underlineStyle={styles.underlineSelectField}
                              inputStyle={styles.h4}
                              style={styles.selectFiledStyle}
                            />
                          </div>
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect}>Código Interno Paquete Prestador</div>
                            <TextField
                              name="txt_fb_codPaquetePres"
                              id="txt_fb_codPaquetePres"
                              value={this.props.filtros.codPaquetePres || ""}
                              onChange={this.CambiarCodPaquetePres}
                              maxLength={15}
                              underlineStyle={styles.underlineSelectField}
                              inputStyle={styles.h4}
                              style={styles.selectFiledStyle}
                            />
                          </div>
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect}> Código Intervencion </div>
                            <TextField
                              name="txt_fb_codIntervencion"
                              id="txt_fb_codIntervencion"
                              value={this.props.filtros.codIntervencion || ""}
                              onChange={this.CambiarCodIntervencion}
                              maxLength={10}
                              underlineStyle={styles.underlineSelectField}
                              inputStyle={styles.h4}
                              style={styles.selectFiledStyle}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect}>Fecha Inicio Vigencia</div>
                            <div className="container">
                              <div className="row" >
                                <DatePicker
                                  name="dp_pq_inicioVigencia"
                                  id="dp_pq_inicioVigencia"
                                  mode="landscape"
                                  DateTimeFormat={customDateTimeFormat.cl()}
                                  locale="es-CL"
                                  firstDayOfWeek={1}
                                  //minDate={minDate}
                                  value={this.props.filtros.inicioVigenciaPaquete}
                                  onChange={this.CambiarInicioVigencia}
                                  onDismiss={() => this.LimpiarInicioVigencia(null)}
                                  underlineStyle={styles.underlineSelectField}
                                  style={styles.datepickerStyle}
                                  inputStyle={styles.h4}
                                  //errorText={this.props.detallePrestacion.inicioVigenciaArancelErr || ""}
                                  errorStyle={{ bottom: "10px" }}
                                />
                                <DateIcon
                                  // iconStyle={{ height: 20, width: 20 }}
                                  style={{ marginTop: 3, marginLeft: 5 }}
                                  color={banmedicaTheme.palette.accent1Color}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect}> Vigencia </div>
                            {
                              this.props.tiposAtencion && this.props.tiposAtencion.length > 0 ?
                                <SelectField
                                  name="dd_fb_vigencia"
                                  id="dd_fb_vigencia"
                                  value={this.props.filtros.vigencia}
                                  onChange={this.CambiarVigencia}
                                  labelStyle={styles.h4}
                                  underlineStyle={styles.underlineSelectField}
                                  style={styles.selectFiledStyle}
                                  iconStyle={styles.iconSelectField}
                                  menuItemStyle={styles.menuItemStyleSelectField}
                                  selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                >
                                  {menuListVigencias}
                                </SelectField>
                                :
                                <CircularProgress />
                            }
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect2}>Tipo de Atributo</div>
                            {
                              this.props.tiposAtencion && this.props.tiposAtencion.length > 0 ?
                                <SelectField
                                  name="dd_fb_tipoAtributo"
                                  id="dd_fb_tipoAtributo"
                                  value={this.props.filtros.tipoAtencion}
                                  onChange={this.CargarAtributosTipo}
                                  labelStyle={styles.h4}
                                  underlineStyle={styles.underlineSelectField}
                                  style={styles.selectFiledStyle}
                                  iconStyle={styles.iconSelectField}
                                  menuItemStyle={styles.menuItemStyleSelectField}
                                  selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                >
                                  {menuListTipoAtributo}
                                </SelectField>
                                :
                                <CircularProgress />
                            }
                          </div>
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect2}> Descripción </div>
                            {
                              this.props.tiposAtencion && this.props.tiposAtencion.length > 0 ?
                                <SelectField
                                  name="dd_fb_Descripción"
                                  id="dd_fb_Descripción"
                                  value={this.props.filtros.tipoAtencion2}
                                  onChange={this.GuardarAtributos}
                                  labelStyle={styles.h4}
                                  underlineStyle={styles.underlineSelectField}
                                  style={styles.selectFiledStyle}
                                  iconStyle={styles.iconSelectField}
                                  menuItemStyle={styles.menuItemStyleSelectField}
                                  selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                >
                                  {menuListTiposAtributoTipo}
                                </SelectField>
                                :
                                <CircularProgress />
                            }
                          </div>
                        </div>
                        <div className="row">
                          <List>
                            {menuListFiltros}
                          </List>
                        </div>
                      </div>
                      :
                      <CircularProgress
                        style={{
                          display: "block",
                          marginLeft: "auto",
                          marginRight: "auto",
                          padding: "50px 50px 100px 50px",
                        }}
                      />
                  }
                  <div className="row" style={{ paddingRight: 25 }}>
                    <div className="col-12" style={styles.colBotonesActualizar}>
                      {
                        !this.props.loadingExcel ?
                          <RaisedButton
                            onClick={this.ExportarExcel}
                            label="Exportar a Excel"
                            backgroundColor="#fff"
                            labelPosition="before"
                            overlayStyle={{ borderRadius: 5 }}
                            labelStyle={{
                              fontSize: "11px", color: "#00A100", paddingLeft: 10, paddingRight: 5, top: "-3px",
                            }}
                            style={{ width: "190px", borderRadius: 5 }}
                            buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                            icon={<Getapp />}
                            disabled={
                              !(this.props.centrosAtencion && this.props.centrosAtencion.length > 0 &&
                                this.props.tiposPrestaciones && this.props.tiposPrestaciones.length > 0 &&
                                this.props.tiposArancel && this.props.tiposArancel.length > 0 &&
                                this.props.tiposAtencion && this.props.tiposAtencion.length > 0) || this.state.disableExcel === true
                            }
                          />
                          :
                          <CircularProgress />
                      }
                      {!this.props.loading ?
                        <RaisedButton
                          label="Buscar"
                          onClick={this.BuscarPaquetes}
                          secondary
                          labelStyle={{ fontSize: "11px" }}
                          overlayStyle={{ borderRadius: 5 }}
                          rippleStyle={{ borderRadius: 5 }}
                          style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                          buttonStyle={{ borderRadius: 5 }}
                          disabled={
                            !(
                              this.props.tiposAtencion && this.props.tiposAtencion.length > 0)
                          }
                        />
                        :
                        <RaisedButton
                          label="Cargando ..."
                          secondary
                          labelStyle={{ fontSize: "11px" }}
                          overlayStyle={{ borderRadius: 5 }}
                          rippleStyle={{ borderRadius: 5 }}
                          style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                          buttonStyle={{ borderRadius: 5 }}
                        />
                      }
                    </div>

                    <div className="contenido" style={{ margin: 0, padding: 0, width: 925 }}>
                      <div style={styles.h3}>Email de contacto</div>
                      <div style={styles.h2}>
                        Las notificaciones se realizarán a la siguiente dirección de correo electrónico:&nbsp;<strong>{this.props.datosUsuario.mail}</strong><br />
                        Si desea modificar el email de contacto, debe cambiarlo en la sección &quot;Datos del Prestador&quot;
                      </div>
                    </div>

                  </div>
                </CardText>
              </Card>
            </div>
            <div className="row" style={{ padding: 10, margin: "15px 0px 0px 0px" }} >
              <div className="col-12">
                <Divider />
              </div>
            </div>

            <GrillaBusquedaPQ CambiosSinGuardar={this.CambiosSinGuardar} />

            <div className="row" style={{ padding: 10, margin: "15px 0px 0px 0px" }}>
              <div className="col-12">
                <Divider />
              </div>
            </div>

            <GrillaSolicitud CambiosSinGuardar={this.CambiosSinGuardar} />

            <Drawer
              width="100%"
              openSecondary
              open={this.props.modalNuevaPrestacion}
              docked={false}

            >
              {(this.props.modalNuevaPrestacion) ?
                <NuevaPrestacionForm CambiosSinGuardar={this.CambiosSinGuardar} />
                : null}
            </Drawer>

            <Dialog
              key="modalCargarBorrador"
              actions={actionsModalCargarBorrador}
              modal
              open={this.props.modalCargarBorrador}
              style={{ width: "100%", fontSize: "13px" }}
            >
              Usted tiene una solicitud incompleta ¿desea continuar la lista o eliminarla?
            </Dialog>

            <ErrorSnack />

            {this.props.solicitudEnCurso ?
              <Dialog
                key="modalSolicitudencurso"
                actions={[
                  <FlatButton
                    label="Aceptar"
                    secondary
                    onClick={this.CloseSetSolicitudesEnCurso}
                  />]}
                modal
                open={this.props.solicitudEnCurso}
                style={{ width: "100%", fontSize: "13px" }}
              >
                <p>Usted tiene solicitudes en curso para los siguientes Paquetes: </p>
                <p>{this.props.paquetesEnCurso.toString()}</p>
                {this.props.prestacionesSolicitud.length > this.props.paquetesEnCurso.length ?
                  <p>Puede eliminar el o los paquetes en curso de la grilla, para poder enviar una nueva modificación.</p> :
                  <p>Debe esperar a que la solicitud esté resuelta, para enviar una nueva modificación.</p>
                }
              </Dialog> : null}
          </div>

          :
          null}
      </div>
    );
  }
}

FiltroBusquedaPQ.defaultProps = {
  idSolicitud: null,
  loading: null,
  loadingExcel: null,
};

FiltroBusquedaPQ.propTypes = {
  loadingExcel: PropTypes.bool,
  loading: PropTypes.bool,
  rutInstitucion: PropTypes.number.isRequired,
  rutPrestador: PropTypes.number.isRequired,
  isapre: PropTypes.string.isRequired,
  tiposArancel: PropTypes.array.isRequired,
  centrosAtencion: PropTypes.array.isRequired,
  tiposPrestaciones: PropTypes.array.isRequired,
  tiposAtencion: PropTypes.array.isRequired,
  tiposAtencion2: PropTypes.array.isRequired,
  modalNuevaPrestacion: PropTypes.bool.isRequired,
  modalCargarBorrador: PropTypes.bool.isRequired,
  //inicioVigenciaPaquete: PropTypes.any.isRequired,
  prestacionesSolicitud: PropTypes.array.isRequired,
  idSolicitud: PropTypes.number,
  solicitudEnCurso: PropTypes.bool.isRequired,
  paquetesEnCurso: PropTypes.any,
  filtros: PropTypes.any.isRequired,
  datosUsuario: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  ENV: PropTypes.any.isRequired,
  token: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  pageSize: state.filtroBusqueda.pageSize,
  totalPaginas: state.filtroBusqueda.totalPaginas,
  loadingExcel: state.filtroBusqueda.loadingExcel,
  loading: state.filtroBusqueda.loading,
  rutPrestador: state.global.rutPrestador,
  isapre: state.global.isapre,
  rutInstitucion: state.global.rutInstitucion,
  tiposArancel: state.global.filtros_CAT.tiposArancel,
  centrosAtencion: state.global.filtros_CAT.centrosAtencion,
  tiposPrestaciones: state.global.filtros_CAT.tiposPrestaciones,
  tiposAtencion: state.filtroBusquedaPQ.tiposAtencion,
  tiposAtencion2: state.filtroBusquedaPQ.tiposAtencion2,
  modalNuevaPrestacion: state.filtroBusquedaPQ.modalNuevaPrestacion,
  modalCargarBorrador: state.filtroBusquedaPQ.modalCargarBorrador,
  prestacionesSolicitud: state.grillaSolicitudPQ.prestacionesSolicitud,
  idSolicitud: state.filtroBusquedaPQ.idSolicitud,
  solicitudEnCurso: state.filtroBusquedaPQ.solicitudEnCurso,
  paquetesEnCurso: state.filtroBusquedaPQ.paquetesEnCurso,
  token: state.global.token,
  filtros: {
    tipoArancel: state.global.filtros_CAT.tipoArancel,
    centroAtencion: state.global.filtros_CAT.centroAtencion,
    tipoPrestacion: state.global.filtros_CAT.tipoPrestacion,
    codFonasa: state.global.filtros_CAT.codFonasa,
    codPrestacion: state.global.filtros_CAT.codPrestacion,
    tipoAtencion: state.filtroBusquedaPQ.filtros.tipoAtencion,
    tipoAtencion2: state.filtroBusquedaPQ.filtros.tipoAtencion2,
    tipoAtencion3: state.filtroBusquedaPQ.filtros.tipoAtencion3,
    inicioVigenciaPaquete: state.filtroBusquedaPQ.filtros.inicioVigenciaPaquete,
    vigencia: state.filtroBusquedaPQ.filtros.vigencia,
    codIntervencion: state.filtroBusquedaPQ.filtros.codIntervencion,
    codPaquetePres: state.filtroBusquedaPQ.filtros.codPaquetePres,
    glosa: state.filtroBusquedaPQ.filtros.glosa,
  },
  datosUsuario: state.global.datosUsuario,
  ENV: state.global.ENV,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(FiltroBusquedaPQ);


// export default FiltroBusqueda;